import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { CheckCheck, Lock } from "lucide-react";

import { api, photoUri } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { AdminPage, Card, Meta } from "@/components/admin-ui";
import { EmptyState, ErrorState, Loading } from "@/components/ui";

// Reviewer queue — only for the verification_reviewer role (backend enforces 403).
export default function ReviewQueue() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isReviewer = !!user?.roles?.includes("verification_reviewer");
  const { data, isLoading, isError, error, refetch } = useQuery({ queryKey: ["review-queue"], queryFn: () => api("/review/applications"), enabled: isReviewer, refetchInterval: 20000 });
  if (user && !isReviewer) return <EmptyState testId="review-forbidden" icon={Lock} title="Reviewer access only" />;
  return (
    <AdminPage title="Verification queue" testId="review-queue-screen">
      <Meta testId="review-queue-count">{data ? `${data.applications.length} pending` : "Loading…"}</Meta>
      {isLoading ? <Loading /> : isError ? <ErrorState testId="review-error" message={error.message} onRetry={() => refetch()} /> : !data.applications.length ? (
        <EmptyState testId="review-empty" icon={CheckCheck} title="Queue is clear." />
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {data.applications.map((item) => (
            <Card key={item.id} testId={`review-item-${item.id}`} onClick={() => navigate(`/review/${item.id}`)}>
              <div className="flex items-center gap-3">
                <img src={photoUri(item.member?.main_photo_url)} alt="" className="h-14 w-14 rounded-full bg-[#F4EBE6] object-cover" />
                <div className="min-w-0 flex-1">
                  <p className="font-bold">{item.member?.full_name} ({item.member?.display_name})</p>
                  <Meta>{item.member?.city}, {item.member?.country} · submitted {item.submitted_at ? new Date(item.submitted_at).toLocaleString() : "-"}</Meta>
                  {item.lock.locked ? <p className="text-xs font-bold text-primary" data-testid={`review-lock-${item.id}`}>{item.lock.by_me ? "Locked by you" : `In review by ${item.lock.by_name}`}</p> : null}
                </div>
              </div>
            </Card>
          ))}
        </div>
      )}
    </AdminPage>
  );
}
